// Utility functions for checking if chart data is valid and has values

// Check if chart data has at least one non-zero value in its datasets
// Returns true if data exists and has values, false otherwise
export const hasChartData = chartData => {
  if (!chartData?.datasets?.length) return false

  // Check if any dataset has at least one non-zero value
  return chartData.datasets.some(dataset => {
    const data = dataset.data || []
    return data.some(value => value != null && value !== 0)
  })
}

// Check if an array of data has at least one non-zero/non-null value
export const hasArrayData = dataArray => {
  if (!Array.isArray(dataArray) || dataArray.length === 0) return false
  return dataArray.some(value => value != null && value !== 0)
}

// Check if an object has at least one non-zero/non-null numeric value
export const hasObjectData = dataObject => {
  if (!dataObject || typeof dataObject !== 'object') return false
  return Object.values(dataObject).some(value => {
    if (typeof value === 'number') return value !== 0
    if (Array.isArray(value)) return hasArrayData(value)
    if (typeof value === 'object') return hasObjectData(value)
    return false
  })
}
